<template>
  <div class="index d-flex p-relative">
    <img class="index-title animate__animated animate__zoomIn" src="../assets/img/indexTitle.png" />
    <img class="index-button animate__animated animate__flash animate__infinite animate__slower"
      src="../assets/img/indexButton.png" @click="startClick()" />
  </div>
</template>

<script>

export default {
  name: "index",
  components: {},
  data() {
    return {

    };
  },
  watch: {},
  methods: {
    startClick() {
      // this.$router.push(`/start`);
      this.$emit("startClick", 'before');
    }
  },
  created() {
  },
  mounted() {

  }
};
</script>

<style lang="scss">
.index {
  background-image: url("../assets/img/indexBg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  width: 100vmin;
  height: 100vmax;
  background-color: #7fe1ee;
}

.index-title {
  position: absolute;
  top: calc(50% - 68.73vmin);
  right: calc(50% - 40vmin);
  width: 53.466vmin;
  height: 137.466vmin;
}

.index-button {
  position: absolute;
  width: 17.6vmin;
  height: 40.53vmin;
  top: calc(50%);
  right: calc(50% + 5vmin);
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue